import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import AdminNavbar from './components/admin-navbar';
import AdminBreadcrumb from './components/admin-breadcrumb';
import AdminSubNav from './components/admin-subnav';
import DistrictFooter from './components/district-footer';
import PublicLayout from './public-layout';
import { useCommunity } from '../hooks/useDistrict';
import { onSubdomain } from '../common/routes/general';
const AdminPageLayout = ({ children }) => {
    const { district } = useCommunity();
    return !onSubdomain ? (_jsxs(PublicLayout, { children: [_jsx(AdminSubNav, {}), _jsx(AdminBreadcrumb, {}), _jsx("main", { className: "bg-light py-4", children: children })] })) : (_jsxs(_Fragment, { children: [_jsx(AdminNavbar, { district: district }), _jsx(AdminBreadcrumb, {}), _jsx("main", { className: "bg-light py-4", children: children }), _jsx(DistrictFooter, { district: district })] }));
};
export default AdminPageLayout;
